import * as THREE from 'three';
import { FikoSahne } from './FikoSahne';
import { FikoIsikOrtamComponent } from './fiko-isiklar/fiko-isik-ortam/fiko-isik-ortam.component';

export class FikoIsikOrtam extends THREE.AmbientLight {
    override type: "FikoIsikOrtam" | any;

    sagButonlar: any[] = [
    ]

    sagMenu: any[] = [
        {
            simge: null,
            baslik: "Gizle / Göster",
            tiklandi: () => {
                this.visible = !this.visible;
                this.sahne.anaGosterim.FikoYT.degisti.emit();
                this.sahne.anaGosterim.ciz();
            }
        },
        {
            simge: null,
            baslik: "Düzenle",
            tiklandi: () => {
                this.sahne.anaGosterim.DialogFiko.ac({
                    bilesen: FikoIsikOrtamComponent,
                    parametreler: { nesne: this },
                    $event: null,
                    ayarlar: { baslik: 'Fiko Ortam Işığı', simgeResim: './simgeler/kurdela.webp' }
                });
            }
        },
    ]

    aracCubugu: any[] = [
    ]

    constructor(public sahne?: FikoSahne, name?: string) {
        super();
        this.name = name;

        this.intensity = 1;
        this.color = new THREE.Color(0xffffffff);
        this.position.set(0, 0, 1);

        this.userData['FikoArayuz'] = {};

        this.userData['FikoArayuz'].agactaGorunur = true;
        this.userData['FikoArayuz'].listeGoster = true;
        this.userData['FikoArayuz'].simge = "./simgeler/kurdela.webp";
    }

    ciftTiklandi() {
        this.sahne.anaGosterim.DialogFiko.ac({
            bilesen: FikoIsikOrtamComponent,
            parametreler: { nesne: this },
            $event: null,
            ayarlar: { baslik: 'Fiko Ortam Işığı', simgeResim: './simgeler/kurdela.webp' }
        });
    }

    /**
     * ✅ Memory Leak Önleme: Resources temizleme
     * AmbientLight'ın shadow map'i yok ama parent referansını temizle
     */
    dispose(): void {
        // Parent'tan kaldır
        if (this.parent) {
            this.parent.remove(this);
        }
    }
} 